import React from "react";
import config from "../../../config/enviroment";
import Button from '../../Ui/Button/index';
var ErrorInfo = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { src: config.urlS3 + "/wom/info/error.png", alt: "error" }),
        React.createElement("h2", null, "En este momento no tienes saldos por pagar"),
        React.createElement("p", null, "El pago que realices ser\u00E1 abonado a tu pr\u00F3xima factura"),
        React.createElement("div", { className: "button-container-errormodal" },
            React.createElement(Button, { onClick: function () { return onClick(); } }, "ABONAR"))));
};
export default ErrorInfo;
